import type { CSSProperties } from 'react';

import TransitionPortal, {
  type TransitionPortalProps,
} from '@/components/Common/TransitionPortal';
import type { ModalOptions, TriggerPos } from '@/components/Select/types';
import useDropdownPos from '@/hooks/pure/useDropdownPos';

import { VFlex } from '../base';

export type DropdownProps = {
  triggerEl?: HTMLElement | null;
  triggerPos?: TriggerPos;
  modalOptions?: ModalOptions;
  modalWidth?: CSSProperties['width'];
  dropdownStyle?: CSSProperties;
} & TransitionPortalProps;

const Dropdown = (props: DropdownProps) => {
  const { dropdownPos, setDropdownRef } = useDropdownPos(props.status, {
    el: props.triggerEl,
    pos: props.triggerPos,
    options: props.modalOptions,
  });

  return (
    <TransitionPortal
      layerId="dropdown-layer"
      status={props.status}
      close={props.close}
      style={{ ...dropdownPos, ...props.style, overflow: 'auto' }}
      animations={props.animations}
    >
      <VFlex
        ref={setDropdownRef}
        style={{
          width: props.modalWidth,
          overflow: 'auto',
          flex: 1,
          ...props.dropdownStyle,
        }}
      >
        {props.children}
      </VFlex>
    </TransitionPortal>
  );
};

export default Dropdown;
